import React, { PropsWithChildren } from 'react'
import EDInputText from '../../../../../Component/EnhancedData/EDInputText'
import { DataWithKey, TextFieldDefinition } from '../../../../../Component/EnhancedData/Types'
import { TaxOptionType } from '../../../../../Type/EnhancedData'

interface TaxAmountInputProps {
  value: number
  onInputChange: (name: string, value: any) => void
  fieldDefinition: DataWithKey<TextFieldDefinition>
  emptyColSpan?: number
  selectedTaxOption?: TaxOptionType
  prefixInput?: string | React.JSX.Element;
  className?: string
  readOnly?: boolean
  disabled?: boolean
  separator?: string
  totalTaxAmount?: number
  onInputError?: (fieldName: string, errorMessage: string | null) => void
}

export function TaxAmountInput (props: PropsWithChildren<TaxAmountInputProps>): React.JSX.Element {
  const { value, fieldDefinition, prefixInput, separator, className, readOnly = false, disabled = false, children } = props

  return (
    <div>
      <EDInputText
        value={value}
        onInputChange={props.onInputChange}
        onInputError={props.onInputError}
        fieldDefinition={fieldDefinition}
        prefixInput={prefixInput}
        separator={separator}
        className={className}
        readOnly={readOnly}
        disabled={disabled}
        runValidationNow={false}
      />
      {children}
    </div>
  )
}

export default function TaxAmountRow (props: TaxAmountInputProps): React.JSX.Element {
  const { value, fieldDefinition, emptyColSpan = 4, selectedTaxOption, totalTaxAmount } = props
  const maxColSpan = 7
  const reservedColSpan = maxColSpan - emptyColSpan

  const prefixInput = '$'
  let separator = '+'
  let readOnly = false
  let disabled = false
  let className = 'subtotal-input label-left'
  const currentTaxAmount = value
  let newTaxAmount = value

  if (selectedTaxOption === 'line-item') {
    readOnly = true
    className = 'subtotal-input label-left static-input'
    newTaxAmount = totalTaxAmount || 0
  } else if (selectedTaxOption === 'exempt') {
    separator = ' '
    disabled = true
    newTaxAmount = 0
  }

  if (currentTaxAmount !== newTaxAmount) {
    props.onInputChange(fieldDefinition.name, newTaxAmount)
  }

  return (
    <tr className="subtotal-row">
      <td colSpan={emptyColSpan}></td>
      <td colSpan={reservedColSpan} className="subtotal-input-cell">
        <TaxAmountInput
          value={newTaxAmount}
          onInputChange={props.onInputChange}
          onInputError={props.onInputError}
          fieldDefinition={fieldDefinition}
          prefixInput={prefixInput}
          separator={separator}
          className={className}
          readOnly={readOnly}
          disabled={disabled}
        />
      </td>
    </tr>
  )
}
